"use client"

import { setBodyOverflow } from "@local/utils/src/setBodyOverflow"
import { create } from "zustand"

interface MenuState {
  isOpen: boolean
  isAnimating: boolean
  toggleOpen: (target?: boolean) => void
}

export const useMenuLayout = create<MenuState>((set) => ({
  isOpen: false,
  isAnimating: false,
  toggleOpen: (target) => {
    set(() => ({ isAnimating: true }))

    const timeout_f = setTimeout(() => {
      set((state) => {
        const newIsOpen = typeof target !== "undefined" ? target : !state.isOpen
        setBodyOverflow(newIsOpen, {
          id: "menu",
        })
        return { isOpen: newIsOpen }
      })
      clearTimeout(timeout_f)
    }, 1)

    const timeout_s = setTimeout(() => {
      set(() => ({ isAnimating: false }))
      clearTimeout(timeout_s)
    }, 300)
  },
}))
